import {Outlet} from "react-router-dom";
import LmsGroupListPage from "@/pages/lms/group/LmsGroupListPage";
import LmsLevelListPage from "@/pages/lms/level/LmsLevelListPage";
import LmsLevelViewPage from "@/pages/lms/level/[id]/LmsLevelViewPage";
import ErrorPage from "@/components/error/ErrorPage";

export const LmsRoute = [
    {
        path: '/lms',
        element: <Outlet/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <LmsGroupListPage/>,
            },
            {
                path: '/lms/group',
                element: <LmsLevelListPage/>,
            },

            {
                path: '/lms/level/:type',
                element: <LmsLevelViewPage/>,
            },

        ],
    },
]